import React from 'react';

import {
  Container,
  LoginBox,
  Title,
  ResetLinkExternal,
  ResetLinkContainer,
  SmallText,
  ContentWrapper,
  FooterContentBox,
} from '../SSOLoginPage.styles';

import AuthLayout from '../../../AuthLayout/Old/AuthLayoutBusiness/AuthLayoutBusiness';
import environment from '../../../../environment';

const SSOBusinessLoginPage = ({ children }) => {
  return (
    <AuthLayout>
      <Container>
        <LoginBox>
          <ContentWrapper>
            <Title>Sign-in</Title>
            <SmallText>Sign in to your account</SmallText>
            {children}
            <ResetLinkContainer>
              <ResetLinkExternal href={`${environment.businessLoginPage}/reset-password`}>
                Forgot your password?
              </ResetLinkExternal>
            </ResetLinkContainer>
          </ContentWrapper>
        </LoginBox>
        <FooterContentBox>
          Having Trouble Signing in? Please{' '}
          <a href={environment.auth.partnerSignUpPage}>Contact Your Partner Success Manager</a> for assistance
        </FooterContentBox>
      </Container>
    </AuthLayout>
  );
};

export default SSOBusinessLoginPage;
